import React from 'react';
import { Box, Typography } from '@mui/material';
import { EstadoBolsa, ESTADOS_LABEL } from '../state/bolsaMachine';
import { COLOR_POR_ESTADO, TOKENS } from '../state/colors';
import { fs } from '../state/typography';

interface StatusBadgeProps {
  estado: EstadoBolsa;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ estado }) => {
  const color = COLOR_POR_ESTADO[estado];
  return (
    <Box
      data-testid="status-badge"
      data-estado={estado}
      sx={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
    >
      <Box sx={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontSize: fs(12.5),
          fontWeight: 500,
          color: TOKENS.ink,
        }}
      >
        {ESTADOS_LABEL[estado]}
      </Typography>
    </Box>
  );
};
